import { deathText } from "./Cover";
import { PrintClient, ScenarioSettings } from "src/types";

const Footer = ({
  scenario,
  client,
  visible,
}: {
  client: PrintClient;
  scenario: ScenarioSettings;
  visible?: boolean;
}) => {
  return (
    <div className={!visible ? "hidden" : ""}>
      <div id="print-footer">
        <div
          style={{
            width: "100%",
            position: "absolute",
            bottom: 5,
            left: 0,
            fontSize: "12px",
            color: "black",
            // backgroundColor: "#f0f0f0",
            display: "flex",
            justifyContent: "space-between",
            WebkitPrintColorAdjust: "exact",
          }}
        >
          <div
            className="flex justify-between border-b "
            style={{
              borderTop: "1px solid #aaa",
              width: "calc(100% - 50px)",
              padding: "10px 20px",
              paddingTop: "20px",
              // color: "black",
              // backgroundColor: "#f0f0f0",
              color: "#444",
              display: "flex",
              justifyContent: "between",
              WebkitPrintColorAdjust: "exact",
              marginLeft: 10,
              marginRight: 10,
            }}
          >
            <div
              style={{
                display: "flex",
                gap: "10px",
                width: "100%",
              }}
            >
              <div>
                Inflation-Adjustment:{" "}
                <b>{`${scenario.inflationType === "Real" ? scenario.inflation || 0 : 0}%`}</b>
              </div>
              {client.people.length > 1 &&
                client.people.map(
                  (person, i) =>
                    scenario.whoDies == i &&
                    scenario.deathYears[i] && (
                      <div key={person.id}>
                        {`${person.name}'s Death: `}
                        <b>{deathText(person, scenario.deathYears[i])}</b>
                      </div>
                    ),
                )}
              {client.people.map(
                (person, i) =>
                  scenario.retirementYears[i] && (
                    <div key={person.id}>
                      {`${person.name}'s Retirement: `}
                      <b>{deathText(person, scenario.retirementYears[i])}</b>
                    </div>
                  ),
              )}
            </div>
            <div style={{ minWidth: "200px", textAlign: "right" }}>
              Prepared on: {new Date().toLocaleDateString()}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
